import { createSelector } from 'reselect';

const getAllAutomationContactLists = state => state.automation.get('contactLists');

export const getAutomationContactListOptions = createSelector(getAllAutomationContactLists, contactLists => {
  const formattedList = [];
  contactLists.forEach(index => {
    const filters = [];

    if (index.filterBranch) {
      index.filterBranch.filterBranches.forEach(filterBranch => {
        filterBranch.filters.forEach(filter => filters.push({
          entityType: filter.entityType,
          searchTerms: filter.searchTerms
        }));
      });
    }

    formattedList.push({
      name: index.name,
      id: index.listId,
      filters
    });
  });
  return formattedList;
});
export const getAutomationContactListRequestStatus = state => state.requestStatus.automationContactLists;

const getAllWorkflows = state => {
  return state.automation.get('workflows');
};

export const getSimpleWorkflows = createSelector(getAllWorkflows, workflows => {
  const simpleWorkflowsByAdId = {};

  for (const adId in workflows) {
    if (adId.length > 0) {
      simpleWorkflowsByAdId[adId] = workflows[adId].filter(workflow => workflow.uuid && workflow.uuid.includes('adss-'));
    }
  }

  return simpleWorkflowsByAdId;
});